import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline';

// Accordion für Frage/Antwort-Paare aus produktContent.FAQ.
const ProductFaq = ({ items, title = 'Häufige Fragen' }) => (
  <section aria-labelledby="faq-heading">
    <h2
      id="faq-heading"
      className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
    >
      {title}
    </h2>
    <dl className="mt-10 divide-y divide-gray-900/10">
      {items.map((item) => (
        <Disclosure
          key={item.question}
          as="div"
          className="py-6 first:pt-0 last:pb-0"
        >
          {({ open }) => (
            <>
              <dt>
                <DisclosureButton className="flex w-full items-start justify-between text-left text-gray-900">
                  <span className="text-base font-semibold leading-7">
                    {item.question}
                  </span>
                  <span className="ml-6 flex h-7 items-center">
                    {open ? (
                      <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                    ) : (
                      <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                    )}
                  </span>
                </DisclosureButton>
              </dt>
              <DisclosurePanel as="dd" className="mt-2 pr-12">
                <p className="text-base leading-7 text-gray-600">
                  {item.answer}
                </p>
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
      ))}
    </dl>
  </section>
);

export default ProductFaq;
